import { render } from "./OurDentist.vue?vue&type=template&id=ec79d966"
import script from "./OurDentist.vue?vue&type=script&lang=js"
export * from "./OurDentist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__